import { Link } from 'react-router-dom'
import styled from 'styled-components'
import media from '../../../../services/generateMediaQueries'
import PrivacyModalLink from '../../../home/PrivacyModalLink/PrivacyModalLink'
import TncModalLink from '../../../home/TncModalLink/TncModalLink'

export const MainContainer = styled.div`
  width: 100%;
  display: flex;
  flex-rirection: row;
  justify-content: space-between;
  align-items: flex-end;
  padding: 30px;
  ${media.lessThan('small')`
    flex-direction: column;
    align-items: center;
    padding-bottom: 80px;
  `}
`
export const LeftContent = styled.div`
  ${media.lessThan('small')`
    display: flex;
    flex-direction: column;
    align-items: center;
  `}
`
export const SocialsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 140px;
  margin-bottom: 18px;
  ${media.lessThan('small')`
    margin-bottom: 0.5rem;
  `}
`
export const LinksContainer = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  ${media.lessThan('small')`
    justify-content: center;
    margin-bottom: 0.5rem;
  `}
`
export const StyledLinkItem = styled.li`
  margin-right: 1rem;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  ${media.lessThan('small')`
    margin-bottom: 0;
    line-height: 1rem;
  `}

  &:last-child {
    margin-right: 0;
  }
`
export const SocialButton = styled.a`
  cursor: pointer;
`
export const SocialImage = styled.div.attrs(props => ({
  style: { WebkitMaskImage: `url('${props.image}')` },
}))`
  background-color: #ffffff;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  width: 32px;
  height: 32px;

  ${media.lessThan('small')`
    background-color: #868686;
  `}
`
export const StyledLink = styled(Link)`
  color: #ffffff !important;
  text-decoration: none;

  &:hover {
    color: var(--color-primary-hover) !important;
  }

  ${media.lessThan('small')`
    color: inherit !important;
    font-size: 11px;
  `}
`
export const StyledTncModalLink = styled(TncModalLink)`
  color: #ffffff;
  text-decoration: none;

  ${media.lessThan('small')`
    color: inherit;
    font-size: 11px;
  `}
`
export const StyledPrivacyModalLink = styled(PrivacyModalLink)`
  color: #ffffff;
  text-decoration: none;

  ${media.lessThan('small')`
    color: inherit;
    font-size: 11px;
  `}
`
export const Copyright = styled.span`
  color: #ffffff;
  text-decoration: none;

  ${media.lessThan('small')`
    color: inherit;
    text-align: center;
    font-size: 11px;
  `}
`
export const PoweredBy = styled.a`
  color: #ffffff !important;
  text-decoration: none;
  text-align: right;

  ${media.lessThan('small')`
    color: inherit;
    text-align: center;
    font-size: 11px;
  `}
`
